import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.Breadcrumbs = class Breadcrumbs extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-breadcrumbs';
	}
	
	constructor(element) {
		super(element);
	}

	render() {
	}
};



// WEBPACK FOOTER //
// ./components/breadcrumbs/scripts/breadcrumbs.js